export default __webpack_public_path__ + "static/media/hackalumni.dcd63a47.png";